/**
 * HVN: Property Inquiry Form block registration.
 *
 * Frontend entry point only. The form markup, submission, validation, spam
 * protection, emails, lead storage and agent assignment all come from the
 * existing Contact Agent system — this block adds no inquiry logic.
 *
 * @package
 * @since   3.5.0
 */

import { registerBlockType } from '@wordpress/blocks';

import metadata from './block.json';
import Edit from './edit';
import icon from '../shared/icon';

registerBlockType( metadata.name, {
	icon,
	edit: Edit,
	save: () => null,
} );
